const ContactManagementModes = Object.freeze({
  LEAD: `lead`,
  COMPANY: `company`
})

const FulfillmentTypes = Object.freeze({
  STANDARD: 'Standard Delivery',
  EQUITY_TRUST: 'DirectLink IRA™ for Equity Trust',
})

const MarkupTypes = Object.freeze({
  FLAT: 'markup_flat',
  PERCENT: 'markup_percent',
})

const MfaMethods = {
  EMAIL: 'email',
  SMS: 'sms',
}

const API_ROLE = `6`

const RoleGroups = Object.freeze({
  PRINCIPAL_OWNER_ROLE_IDS: [`2`],
  AUTHORIZED_TRADER_ROLE_IDS: [`1`, `2`, `7`, `8`],
  SALES_MANAGER_ROLE_IDS: [`7`],
  SALES_REP_ROLE_IDS: [`8`],
  ACCOUNTING_ROLE_IDS: [`1`, `2`, `4`],
  API_ROLE_IDS: [API_ROLE],
})

const TradingRoles = Object.freeze({
  AUTHORIZED_TRADER: `authorized_trader`,
  SALES_MANAGER: `sales_manager`,
  SALES_REP: `sales_rep`,
})

const BankTranTypes = {
  DEBIT: `debit`,
  DEPOSIT: `deposit`,
}

//TODO look into having the entity status values returned by the API as constants.
const CompanyEntityStatus = {
  LEAD_STATUS_IDS: ['6','7', '12', '8','11','22','21','23'],
  GOOD_STANDING_ID: 13
}

const BankAccountStates = {
  NOT_ACTIVE: 'Not Active',
  ACTIVE: 'Active',
  PENDING: 'Pending',
}

const ACH_PAYMENT_IDS = ['28', '17', '13', '20'];

const MAX_SHIPPING_HOLD_DAYS = 28

// Canonical business timezone — both client and server must evaluate "today" in
// this zone so that date-boundary checks (shipping hold, ACH debit, etc.) agree.
// Mirrors platformgold-api/models/primary/sales-orders/constants.js BUSINESS_TIMEZONE.
const BUSINESS_TIMEZONE = 'America/New_York'

const MAX_ACH_DEBIT_DAYS = 7

const UNITED_STATES = `US`

const MARKET_CLOSE_MST_HOUR = 16 //16 = 4pm

// RFC 4122 UUID v4 format; used to filter valid spot lock IDs from aggregated placeholders
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

// Warehouse locations - mirrors platformgold-api/micro-services/warehouse-locations/constants.js
const Warehouses = Object.freeze({
  NEW_YORK: 'NEW_YORK',
  COLORADO: 'COLORADO',
})

// NetSuite Location internal IDs for warehouses
const WarehouseNetsuiteIds = Object.freeze({
  [Warehouses.NEW_YORK]: '1',
  [Warehouses.COLORADO]: '13',
})

const EVENT_PROVIDERS = Object.freeze({
  LOGZIO: 'LOGZIO',
  GA: 'GA',
})

const ANALYTICS_EVENTS = Object.freeze({
  VIEW_CART: 'view_cart',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  UPDATE_CART_QUANTITY: 'update_cart_quantity',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  SEARCH: 'search',
  APPLY_FILTER_SORT: 'apply_filter_or_sort',
  FAV_ADD: 'add_to_favorites',
  FAV_REMOVE: 'remove_from_favorites',
  STOCK_ALERT: 'create_stock_alert',
  VIEW_ORDER_HISTORY: 'view_order_history',
  VIEW_ORDER_DETAILS: 'view_order_details',
  LIMIT_CREATE: 'create_limit_order',
  LIMIT_CANCEL: 'cancel_limit_order',
  LOGIN: 'login',
  VIEW_ITEM: 'view_item',
  SIGN_UP: 'sign_up',
  FE_ACTIVITY: 'fe_activity',
});

export {
  UUID_REGEX,
  ContactManagementModes,
  FulfillmentTypes,
  CompanyEntityStatus,
  MarkupTypes,
  MfaMethods,
  RoleGroups,
  TradingRoles,
  BankTranTypes,
  BankAccountStates,
  ACH_PAYMENT_IDS,
  MAX_SHIPPING_HOLD_DAYS,
  BUSINESS_TIMEZONE,
  MAX_ACH_DEBIT_DAYS,
  UNITED_STATES,
  MARKET_CLOSE_MST_HOUR,
  API_ROLE,
  EVENT_PROVIDERS,
  ANALYTICS_EVENTS,
  Warehouses,
  WarehouseNetsuiteIds
}
